// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'

import axios from 'axios'
import { API_BASE, cableUrl } from '@/shared/lib/apiBase'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import ActionCableVue from "actioncable-vue";
import VueCookies from 'vue-cookies'
import ExpandableImage from '@/components/Helpers/ExpandableImage.vue'

import './plugins/toast'
import { registerClientAuthGuard } from '@/store/modules/client'


// Тема приложения. Импортируется последней, чтобы переопределять стили Vuetify.
import './styles/theme.css';
import { can } from '@/shared/lib/access'
Vue.prototype.$can = permission => can(store.state.user, permission)

import { preferredTheme, applyTheme } from '@/shared/lib/theme'

Vue.config.productionTip = true

// Светлая или тёмная — до создания приложения: иначе страница успевает
// моргнуть светлым на каждой загрузке.
applyTheme(preferredTheme(), vuetify)

Vue.use(VueCookies, {
  // options here
})
Vue.prototype.moment = moment
axios.defaults.baseURL = API_BASE
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.prototype.$http = axios

// Вход и выход отвечают 401 штатно: у первого это неверный пароль, у
// второго — уже недействительная сессия. Разлогинивать по ним нельзя,
// иначе logout вызывает сам себя по кругу.
const AUTH_ROUTES = ['/api/authenticate', '/api/logout']

// Глобальный перехватчик: истёкшая сессия → автоматический logout
axios.interceptors.response.use(
  response => response,
  error => {
    const url = (error.config && error.config.url) || ''
    const selfInflicted = AUTH_ROUTES.some(route => url.includes(route))

    // В кабинете операторский 401 ничего не значит: у клиента свой токен и свой
    // вход. Раньше протухшая операторская кука в том же браузере выбрасывала
    // клиента из кабинета на операторский логин с «Not Authorized».
    const inClientArea = router.currentRoute.path.startsWith('/client')

    if (error.response && error.response.status === 401 && !selfInflicted && store.getters.isLoggedIn && !inClientArea) {
      store.dispatch('logout').then(() => {
        router.push('/login')
      })
    }
    return Promise.reject(error)
  }
)

// Истёкший клиентский токен так же уводит на клиентский вход, как операторский —
// на операторский; перехватчик живёт в своём axios-клиенте.
registerClientAuthGuard(store, router)

const token = VueCookies.get('token')
const work_shift = VueCookies.get('work_shift')

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

// Миниатюра снимка: своя, вместо vue-expandable-image. Та умела только
// разворачивать одну картинку — ни Esc, ни листания соседних не было.
Vue.component('expandable-image', ExpandableImage)

Vue.use(ActionCableVue, {
  debug: !Vue.config.productionTip,
  debugLevel: "error",
  connectionUrl: cableUrl(token), // адрес берётся из текущего хоста, см. shared/lib/apiBase
  connectImmediately: false,
});

Vue.filter('textTruncate', function (value, length) {
  if (!value) return ''
  value = value.toString()
  if (value.length > length) {
    return value.substring(0, length) + '...'
  } else {
    return value
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  axios,
  store,
  components: { App },
  template: '<App/>'
})
